import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=a3ffd77e&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"
import style0 from "./follow.vue?vue&type=style&index=0&id=a3ffd77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ffd77e",
  null
  
)

export default component.exports